var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['node-container', 'divider-container', _vm.rowTypeClass, _vm.blockWidthClass, _vm.dividerPadding]},[_c('div',{staticClass:"divider-content"},[_c('hr',{staticClass:"divider",class:_vm.dividerType})])])}
var staticRenderFns = []

export { render, staticRenderFns }